/* eslint-disable @typescript-eslint/no-magic-numbers */
import { AbstractControl, ValidationErrors } from '@angular/forms';

const postcodeRegex = /^[0-9]{2}-[0-9]{3}$/;

const PostCodeValidator = (formControl: AbstractControl): ValidationErrors | null => {
  const value = formControl && (formControl.value as string);

  if (!value) {
    return {};
  }

  const postCode = !postcodeRegex.test(value);

  if (!postCode) {
    return {};
  }

  return { postCode };
};

export default PostCodeValidator;
